var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiveGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 19,
    height: 11,
    fill: "#F7BFCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 27.2607H24.1202C24.7049 27.2607 25.179 26.7867 25.179 26.2019V16.6725",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.3784C4 11.8261 4.44772 11.3784 5 11.3784H26.2941C26.8464 11.3784 27.2941 11.8261 27.2941 12.3784V15.6725C27.2941 16.2248 26.8464 16.6725 26.2941 16.6725H5C4.44772 16.6725 4 16.2248 4 15.6725V12.3784Z",
    fill: "#F7BFCC",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6445 27.2608V11.3784",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6645 8.38408C19.8903 9.77539 17.8533 10.7939 15.6758 11.3784C16.2603 9.20089 17.2788 7.1639 18.6701 5.38973C20.5323 3.52902 21.5868 3.8142 22.4198 4.64149C23.2527 5.46879 23.5266 6.52338 21.6645 8.38408Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62569 8.38408C11.4 9.77513 13.437 10.7936 15.6144 11.3784C15.0305 9.20064 14.0119 7.16352 12.62 5.38973C10.7593 3.52902 9.70475 3.8142 8.87181 4.64149C8.03887 5.46879 7.76499 6.52338 9.62569 8.38408Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555 27.2607H7.179C6.59423 27.2607 6.12017 26.7867 6.12017 26.2019V16.6725",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveGift);
export default __webpack_public_path__ + "static/media/give-gift.585224932f33ec704fcf7bfa09d80c64.svg";
export { ForwardRef as ReactComponent };